exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 993px) {\n.search[data-v-5ead6116] {\n    margin-top: 80px;\n}\n.page-content[data-v-5ead6116] {\n    padding-top: 123px;\n}\n}\n@media (max-width: 992px) {\n.search[data-v-5ead6116] {\n    margin-top: 44px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ead6116","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/services/payments/CMContactDebtorList.vue
// module id = 1140
// module chunks = 2